module.exports = __webpack_public_path__ + "d94e20c1/img/send-icon.3cfb6275.svg";